import React from 'react';
import styles from './styles.module.scss';

const ComingSoonStatPanel = () => /*#__PURE__*/React.createElement("div", {
  className: styles.container
}, /*#__PURE__*/React.createElement("span", {
  className: styles.span
}, "Coming soon..."));

export default ComingSoonStatPanel;